import { testDataCreator } from '@wix/answers-lib';
import { ScenarioConditionType, ScenarioOperator } from '.';
import { spotterEmptyConditionMap } from './conditions';
export var scenarioPriorityConditionBuilder = testDataCreator(function () { return ({
    conditionType: ScenarioConditionType.TICKET_PRIORITY,
    ticketPriorities: [],
    operator: ScenarioOperator.ANY_OF,
}); });
export var scenarioLabelsConditionBuilder = testDataCreator(function () { return ({
    conditionType: ScenarioConditionType.LABEL,
    labelIds: [],
    operator: ScenarioOperator.ANY_OF
}); });
export var scenarioTicketAssigneeConditionBuilder = testDataCreator(function () { return ({
    conditionType: ScenarioConditionType.TICKET_ASSIGNEE,
    assignedUserIds: [],
    assignedGroupIds: [],
    operator: ScenarioOperator.ANY_OF,
}); });
export var scenarioAgentRoleConditionBuilder = testDataCreator(function () { return ({
    conditionType: ScenarioConditionType.AGENT_ROLE,
    roleIds: [],
    operator: ScenarioOperator.ANY_OF,
}); });
export var scenarioAgentLocationConditionBuilder = testDataCreator(function () { return ({
    conditionType: ScenarioConditionType.AGENT_LOCATION,
    locationIds: [],
    operator: ScenarioOperator.ANY_OF
}); });
export var scenarioWidgetConditionBuilder = testDataCreator(function () { return ({
    conditionType: ScenarioConditionType.CHAT_WIDGET,
    widgetIds: [],
    operator: ScenarioOperator.ANY_OF
}); });
export var scenarioAgentGroupConditionBuilder = testDataCreator(function () { return ({
    conditionType: ScenarioConditionType.AGENT_GROUP,
    groupIds: [],
    operator: ScenarioOperator.ANY_OF
}); });
export var scenarioTicketStatusConditionBuilder = testDataCreator(function () { return ({
    conditionType: ScenarioConditionType.TICKET_STATUS,
    ticketStatuses: [],
    operator: ScenarioOperator.ANY_OF,
}); });
export var scenarioLocalesConditionBuilder = testDataCreator(function () { return ({
    conditionType: ScenarioConditionType.LOCALE,
    locales: [],
    operator: ScenarioOperator.ANY_OF,
}); });
export var scenarioArticleTypesConditionBuilder = testDataCreator(function () { return ({
    conditionType: ScenarioConditionType.ARTICLE_TYPE,
    articleTypes: [],
    operator: ScenarioOperator.ANY_OF,
}); });
export var scenarioCompaniesConditionBuilder = testDataCreator(function () { return ({
    conditionType: ScenarioConditionType.COMPANY,
    companyIds: [],
    operator: ScenarioOperator.ANY_OF,
}); });
export var scenarioTicketRepliesCountConditionBuilder = testDataCreator(function () { return ({
    conditionType: ScenarioConditionType.TICKET_REPLIES_COUNT,
    count: null,
    operator: ScenarioOperator.GREATER_THAN,
}); });
export var scenarioArticleLinkedTicketsCountConditionBuilder = testDataCreator(function () { return ({
    conditionType: ScenarioConditionType.ARTICLE_LINKED_TICKETS_COUNT,
    count: null,
    operator: ScenarioOperator.GREATER_THAN,
}); });
export var scenarioArticleViewsCountConditionBuilder = testDataCreator(function () { return ({
    conditionType: ScenarioConditionType.ARTICLE_VIEWS_COUNT,
    count: null,
    operator: ScenarioOperator.GREATER_THAN,
}); });
export var scenarioArticleVotesCountConditionBuilder = testDataCreator(function () { return ({
    conditionType: ScenarioConditionType.ARTICLE_VOTES_COUNT,
    count: null,
    operator: ScenarioOperator.GREATER_THAN,
}); });
export var scenarioPhoneCallCountryConditionBuilder = testDataCreator(function () { return ({
    conditionType: ScenarioConditionType.PHONE_CALL_COUNTRY,
    countryCodes: [],
    operator: ScenarioOperator.ANY_OF,
}); });
export var scenarioQueuesConditionBuilder = testDataCreator(function () { return ({
    conditionType: ScenarioConditionType.QUEUE,
    queueIds: [],
    operator: ScenarioOperator.ANY_OF,
}); });
export var scenarioCallLineConditionBuilder = testDataCreator(function () { return ({
    conditionType: ScenarioConditionType.LINE,
    lineIds: [],
    operator: ScenarioOperator.ANY_OF,
}); });
export var scenarioTicketChannelConditionBuilder = testDataCreator(function () { return ({
    conditionType: ScenarioConditionType.TICKET_CHANNEL,
    channels: [],
    operator: ScenarioOperator.ANY_OF,
}); });
export var scenarioTicketMailboxConditionBuilder = testDataCreator(function () { return ({
    conditionType: ScenarioConditionType.TICKET_MAILBOX,
    mailboxIds: [],
    operator: ScenarioOperator.ANY_OF,
}); });
export var scenarioArticleCategoryConditionBuilder = testDataCreator(function () { return ({
    conditionType: ScenarioConditionType.ARTICLE_CATEGORY,
    categoryIds: [],
    operator: ScenarioOperator.ANY_OF,
}); });
export var scenarioCompanyMultiSelectCustomFieldConditionBuilder = testDataCreator(function () { return ({
    conditionType: ScenarioConditionType.COMPANY_MULTI_SELECT_CUSTOM_FIELD,
    customFieldId: '',
    operator: ScenarioOperator.ANY_OF,
    values: []
}); });
export var scenarioUserMultiSelectCustomFieldConditionBuilder = testDataCreator(function () { return ({
    conditionType: ScenarioConditionType.USER_MULTI_SELECT_CUSTOM_FIELD,
    customFieldId: '',
    operator: ScenarioOperator.ANY_OF,
    values: []
}); });
export var scenarioAgentMultiSelectCustomFieldConditionBuilder = testDataCreator(function () { return ({
    conditionType: ScenarioConditionType.AGENT_MULTI_SELECT_CUSTOM_FIELD,
    customFieldId: '',
    operator: ScenarioOperator.ANY_OF,
    values: [],
}); });
export var scenarioTicketNumberCustomFieldConditionBuilder = testDataCreator(function () { return ({
    conditionType: ScenarioConditionType.TICKET_NUMBER_CUSTOM_FIELD,
    customFieldId: null,
    operator: ScenarioOperator.IS,
    from: null,
    to: null,
}); });
export var scenarioTicketBooleanCustomFieldConditionBuilder = testDataCreator(function () { return ({
    conditionType: ScenarioConditionType.TICKET_BOOLEAN_CUSTOM_FIELD,
    customFieldId: null,
    operator: ScenarioOperator.IS,
    boolValue: null,
}); });
export var scenarioCompanyNumberCustomFieldConditionBuilder = testDataCreator(function () { return ({
    conditionType: ScenarioConditionType.COMPANY_NUMBER_CUSTOM_FIELD,
    customFieldId: null,
    operator: ScenarioOperator.IS,
    from: null,
    to: null,
}); });
export var scenarioCompanyBooleanCustomFieldConditionBuilder = testDataCreator(function () { return ({
    conditionType: ScenarioConditionType.COMPANY_BOOLEAN_CUSTOM_FIELD,
    customFieldId: null,
    operator: ScenarioOperator.IS,
    boolValue: null,
}); });
export var scenarioUserNumberCustomFieldConditionBuilder = testDataCreator(function () { return ({
    conditionType: ScenarioConditionType.USER_NUMBER_CUSTOM_FIELD,
    customFieldId: null,
    operator: ScenarioOperator.IS,
    from: null,
    to: null,
}); });
export var scenarioUserBooleanCustomFieldConditionBuilder = testDataCreator(function () { return ({
    conditionType: ScenarioConditionType.USER_BOOLEAN_CUSTOM_FIELD,
    customFieldId: null,
    operator: ScenarioOperator.IS,
    boolValue: null,
}); });
export var scenarioAgentNumberCustomFieldConditionBuilder = testDataCreator(function () { return ({
    conditionType: ScenarioConditionType.AGENT_NUMBER_CUSTOM_FIELD,
    customFieldId: null,
    operator: ScenarioOperator.IS,
    from: null,
    to: null,
}); });
export var scenarioAgentBooleanCustomFieldConditionBuilder = testDataCreator(function () { return ({
    conditionType: ScenarioConditionType.AGENT_BOOLEAN_CUSTOM_FIELD,
    customFieldId: null,
    operator: ScenarioOperator.IS,
    boolValue: null,
}); });
export var scenarioTicketSingleSelectCustomFieldConditionBuilder = testDataCreator(function () { return ({
    conditionType: ScenarioConditionType.TICKET_SINGLE_SELECT_CUSTOM_FIELD,
    customFieldId: '',
    operator: ScenarioOperator.ANY_OF,
    values: [],
}); });
export var scenarioCompanySingleSelectCustomFieldConditionBuilder = testDataCreator(function () { return ({
    conditionType: ScenarioConditionType.COMPANY_SINGLE_SELECT_CUSTOM_FIELD,
    customFieldId: '',
    operator: ScenarioOperator.ANY_OF,
    values: []
}); });
export var scenarioUserSingleSelectCustomFieldConditionBuilder = testDataCreator(function () { return ({
    conditionType: ScenarioConditionType.USER_SINGLE_SELECT_CUSTOM_FIELD,
    customFieldId: '',
    operator: ScenarioOperator.ANY_OF,
    values: []
}); });
export var scenarioAgentSingleSelectCustomFieldConditionBuilder = testDataCreator(function () { return ({
    conditionType: ScenarioConditionType.AGENT_SINGLE_SELECT_CUSTOM_FIELD,
    customFieldId: '',
    operator: ScenarioOperator.ANY_OF,
    values: [],
}); });
export var scenarioConditionBuilder = function (conditionType, override) {
    return testDataCreator(spotterEmptyConditionMap(conditionType))(override);
};
//# sourceMappingURL=conditions.builders.js.map